import React, { useState, useEffect, useContext } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import SpiderChart360 from './SpiderChart360';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { applyFullTieOrder } from '../../../../utils/quadrantTieOrder';

const AlignmentFlowSecond360 = ({ apiData, reportType, pageNumber }) => {
  const [snapshotResult, setSnapshotResults] = useState([]);
  const [starterLabel, setStarterLabel] = useState([]);
  const [variablsMapArray, setVariableMapArray] = useState();
  // Leadership chart data
  const [leadershipResult, setLeadershipResult] = useState([]);
  const [leadershipLabel, setLeadershipLabel] = useState([]);
  const [scoreRanking, setScoreRanking] = useState([])
  const [scoreRankingOne, setScoreRankingOne] = useState([])

  const { averagePercentages, averagePercentagesLeadership } = useContext(GroupReportContext)

  const SquareWithArrowTwo = () => {

    const leadershipScores = {
      strategic: scoreRanking.find(item => item.name.toLowerCase() === 'strategic')?.value || 0,
      performance: scoreRanking.find(item => item.name.toLowerCase() === 'performance')?.value || 0,
      visionary: scoreRanking.find(item => item.name.toLowerCase() === 'visionary')?.value || 0,
      collaborative: scoreRanking.find(item => item.name.toLowerCase() === 'collaborative')?.value || 0
    };

    const sortedLeadership = applyFullTieOrder(
      Object.entries(leadershipScores).sort((a, b) => b[1] - a[1]),
      ([name]) => name,
      ([, value]) => value
    ).map(([name, value]) => ({
      name: name.charAt(0).toUpperCase() + name.slice(1),
      value: Math.round(value)
    }));

    const diagramSize = 206;
    const headLength = 14;
    const headWidth = 8;
    const centerOffsetX = diagramSize / 2;
    const centerOffsetY = diagramSize / 2;
    const quadrantOffsetX = centerOffsetX / 2;
    const quadrantOffsetY = centerOffsetY / 2;

    const quadrantCenters = {
      strategic: { x: quadrantOffsetX, y: quadrantOffsetY },
      performance: { x: diagramSize - quadrantOffsetX, y: quadrantOffsetY },
      visionary: { x: quadrantOffsetX, y: diagramSize - quadrantOffsetY },
      collaborative: { x: diagramSize - quadrantOffsetX, y: diagramSize - quadrantOffsetY }
    };

    const pathPoints = sortedLeadership.map(step => quadrantCenters[step.name.toLowerCase()]);

    let arrowPath = '';
    if (pathPoints.length > 0) {
      const pointsForPath = [...pathPoints];
      if (pointsForPath.length > 1) {
        const tip = pointsForPath[pointsForPath.length - 1];
        const prev = pointsForPath[pointsForPath.length - 2];
        const dx = tip.x - prev.x;
        const dy = tip.y - prev.y;
        const len = Math.hypot(dx, dy) || 1;
        const trimmedTip = {
          x: tip.x - (headLength * dx) / len,
          y: tip.y - (headLength * dy) / len
        };
        pointsForPath[pointsForPath.length - 1] = trimmedTip;
      }

      arrowPath = `M ${pointsForPath[0].x} ${pointsForPath[0].y}`;
      for (let i = 1; i < pointsForPath.length; i++) {
        arrowPath += ` L ${pointsForPath[i].x} ${pointsForPath[i].y}`;
      }
    }

    const dotPosition = sortedLeadership[0] ?
      quadrantCenters[sortedLeadership[0].name.toLowerCase()] :
      { x: 0, y: 0 };

    const arrowColor = '#B6111F';
    let arrowHeadPoints = '';



    if (sortedLeadership.length > 1) {
      const lastIdx = sortedLeadership.length - 1;
      const tip = quadrantCenters[sortedLeadership[lastIdx].name.toLowerCase()];
      const prev = quadrantCenters[sortedLeadership[lastIdx - 1].name.toLowerCase()];
      const angle = Math.atan2(tip.y - prev.y, tip.x - prev.x);
      const left = {
        x: tip.x - headLength * Math.cos(angle) + headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) - headWidth * Math.cos(angle)
      };
      const right = {
        x: tip.x - headLength * Math.cos(angle) - headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) + headWidth * Math.cos(angle)
      };
      arrowHeadPoints = `${tip.x},${tip.y} ${left.x},${left.y} ${right.x},${right.y}`;
    }

    return (
      <div style={{ position: 'relative', width: `${diagramSize}px`, height: `${diagramSize}px`, backgroundColor: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #000000' }}>
        <div style={{ position: 'absolute', width: '2px', height: '100%', backgroundColor: '#000', left: '50%', transform: 'translateX(-50%)' }}></div>
        <div style={{ position: 'absolute', width: '100%', height: '2px', backgroundColor: '#000', top: '50%', transform: 'translateY(-50%)' }}></div>

        <div style={{ position: 'absolute', top: '5px', left: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>STRATEGIC</div>
        <div style={{ position: 'absolute', top: '20px', left: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>
          {typeof leadershipScores.strategic === 'number' ? leadershipScores.strategic.toFixed(2) : '0.00'}%
        </div>

        <div style={{ position: 'absolute', top: '5px', right: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>PERFORMANCE</div>
        <div style={{ position: 'absolute', top: '20px', right: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>
          {typeof leadershipScores.performance === 'number' ? leadershipScores.performance.toFixed(2) : '0.00'}%
        </div>

        <div style={{ position: 'absolute', bottom: '5px', left: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>VISIONARY</div>
        <div style={{ position: 'absolute', bottom: '20px', left: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>
          {typeof leadershipScores.visionary === 'number' ? leadershipScores.visionary.toFixed(2) : '0.00'}%
        </div>

        <div style={{ position: 'absolute', bottom: '5px', right: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>COLLABORATIVE</div>
        <div style={{ position: 'absolute', bottom: '20px', right: '10px', color: '#000', fontFamily: 'Helvetica', fontWeight: 700, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px', leadingTrim: 'none' }}>
          {typeof leadershipScores.collaborative === 'number' ? leadershipScores.collaborative.toFixed(2) : '0.00'}%
        </div>


        <svg width={diagramSize} height={diagramSize} style={{ position: 'absolute', top: 0, left: 0 }}>
          <circle cx={dotPosition.x} cy={dotPosition.y} r="8" fill={arrowColor} />
          <path
            d={arrowPath}
            stroke={arrowColor}
            strokeWidth="4"
            strokeOpacity="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          {arrowHeadPoints && (
            <polygon points={arrowHeadPoints} fill={arrowColor} stroke={arrowColor} />
          )}
        </svg>

      </div>
    );
  };

  const SquareWithArrow = () => {

    const topLeft = 'MIND';
    const topRight = 'STRENGTH';
    const bottomLeft = 'SOUL';
    const bottomRight = 'HEART';

    const topLeftValue = (scoreRankingOne.find(s => s.name === 'mind')?.value || 0).toFixed(2);
    const topRightValue = (scoreRankingOne.find(s => s.name === 'strength')?.value || 0).toFixed(2);
    const bottomLeftValue = (scoreRankingOne.find(s => s.name === 'soul')?.value || 0).toFixed(2);
    const bottomRightValue = (scoreRankingOne.find(s => s.name === 'heart')?.value || 0).toFixed(2);

    const labelStyle = { color: '#000', fontSize: '10px', fontWeight: '700', fontFamily: 'Helvetica, sans-serif', textTransform: 'uppercase', position: 'absolute', lineHeight: '1.2' };

    const percentageStyle = { color: '#000', fontSize: '10px', fontWeight: '700', fontFamily: 'Helvetica, sans-serif', position: 'absolute', lineHeight: '1.2' };


    const diagramSize = 206;
    const headLength = 14;
    const headWidth = 8;
    const centerOffsetX = diagramSize / 2;
    const centerOffsetY = diagramSize / 2;
    const quadrantOffsetX = centerOffsetX / 2;
    const quadrantOffsetY = centerOffsetY / 2;

    const quadrantCenters = {
      mind: { x: quadrantOffsetX, y: quadrantOffsetY },
      strength: { x: diagramSize - quadrantOffsetX, y: quadrantOffsetY },
      soul: { x: quadrantOffsetX, y: diagramSize - quadrantOffsetY },
      heart: { x: diagramSize - quadrantOffsetX, y: diagramSize - quadrantOffsetY }
    };

    // Get scores for each quadrant
    const quadrantScores = [
      { name: 'mind', score: scoreRankingOne.find(s => s.name === 'mind')?.value || 0 },
      { name: 'strength', score: scoreRankingOne.find(s => s.name === 'strength')?.value || 0 },
      { name: 'soul', score: scoreRankingOne.find(s => s.name === 'soul')?.value || 0 },
      { name: 'heart', score: scoreRankingOne.find(s => s.name === 'heart')?.value || 0 }
    ];

    const sortedQuadrants = applyFullTieOrder(
      [...quadrantScores].sort((a, b) => b.score - a.score),
      (q) => q.name,
      (q) => q.score
    ).map(({ name, score }) => ({
      name: name.charAt(0).toUpperCase() + name.slice(1),
      value: score
    }));


    const pathPoints = sortedQuadrants.map(step => quadrantCenters[step.name.toLowerCase()]);



    let arrowPath = '';
    if (pathPoints.length > 0) {
      const pointsForPath = [...pathPoints];
      if (pointsForPath.length > 1) {
        const tip = pointsForPath[pointsForPath.length - 1];
        const prev = pointsForPath[pointsForPath.length - 2];
        const dx = tip.x - prev.x;
        const dy = tip.y - prev.y;
        const len = Math.hypot(dx, dy) || 1;
        const trimmedTip = {
          x: tip.x - (headLength * dx) / len,
          y: tip.y - (headLength * dy) / len
        };
        pointsForPath[pointsForPath.length - 1] = trimmedTip;
      }

      arrowPath = `M ${pointsForPath[0].x} ${pointsForPath[0].y}`;
      for (let i = 1; i < pointsForPath.length; i++) {
        arrowPath += ` L ${pointsForPath[i].x} ${pointsForPath[i].y}`;
      }
    }

    const dotPosition = sortedQuadrants[0] ?
      quadrantCenters[sortedQuadrants[0].name.toLowerCase()] :
      { x: 0, y: 0 };

    const arrowColor = '#B6111F';
    let arrowHeadPoints = '';



    if (sortedQuadrants.length > 1) {
      const lastIdx = sortedQuadrants?.length - 1;
      const tip = quadrantCenters[sortedQuadrants[lastIdx].name.toLowerCase()];
      const prev = quadrantCenters[sortedQuadrants[lastIdx - 1].name.toLowerCase()];
      const angle = Math.atan2(tip.y - prev.y, tip.x - prev.x);
      const left = {
        x: tip.x - headLength * Math.cos(angle) + headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) - headWidth * Math.cos(angle)
      };
      const right = {
        x: tip.x - headLength * Math.cos(angle) - headWidth * Math.sin(angle),
        y: tip.y - headLength * Math.sin(angle) + headWidth * Math.cos(angle)
      };
      arrowHeadPoints = `${tip.x},${tip.y} ${left.x},${left.y} ${right.x},${right.y}`;
    }

    return (
      <div style={{ position: 'relative', width: '206px', height: '206px', backgroundColor: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #000' }}>

        <div style={{ ...labelStyle, top: '6px', left: '10px' }}>
          {topLeft}
        </div>
        <div style={{ ...labelStyle, top: '6px', right: '10px' }}>
          {topRight}
        </div>

        <div style={{ ...percentageStyle, top: '20px', left: '10px' }}>
          {topLeftValue}%
        </div>

        <div style={{ ...percentageStyle, top: '20px', right: '10px' }}>
          {topRightValue}%
        </div>

        <div style={{ ...percentageStyle, bottom: '23px', left: '10px' }}>
          {bottomLeftValue}%
        </div>
        <div style={{ ...labelStyle, bottom: '10px', left: '10px' }}>
          {bottomLeft}
        </div>

        <div style={{ ...percentageStyle, bottom: '23px', right: '10px' }}>
          {bottomRightValue}%
        </div>
        <div style={{ ...labelStyle, bottom: '10px', right: '10px' }}>
          {bottomRight}
        </div>

        {/* Vertical divider */}
        <div style={{ position: 'absolute', width: '2px', height: '100%', backgroundColor: '#000' }}></div>

        {/* Horizontal divider */}
        <div style={{ position: 'absolute', width: '100%', height: '2px', backgroundColor: '#000' }}></div>

        <svg width={diagramSize} height={diagramSize} style={{ position: 'absolute', top: 0, left: 0 }}>
          <circle cx={dotPosition.x} cy={dotPosition.y} r="8" fill={arrowColor} />
          <path
            d={arrowPath}
            stroke={arrowColor}
            strokeWidth="4"
            strokeOpacity="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          {arrowHeadPoints && (
            <polygon points={arrowHeadPoints} fill={arrowColor} stroke={arrowColor} />
          )}
        </svg>
      </div>
    );
  }

  useEffect(() => {

    if (averagePercentages && averagePercentagesLeadership) {

      const strength = averagePercentages?.find((el) => el?.name == "Strength")?.avg
      const heart = averagePercentages?.find((el) => el?.name == "Heart")?.avg
      const soul = averagePercentages?.find((el) => el?.name == "Soul")?.avg
      const mind = averagePercentages?.find((el) => el?.name == "Mind")?.avg

      const strategic = averagePercentagesLeadership?.find((el) => el?.name == "Strategic")?.avg
      const visionary = averagePercentagesLeadership?.find((el) => el?.name == "Visionary")?.avg
      const collaborative = averagePercentagesLeadership?.find((el) => el?.name == "Collaborative")?.avg
      const performance = averagePercentagesLeadership?.find((el) => el?.name == "Performance")?.avg

      const RankedScoresOne = [
        { name: "heart", value: parseFloat(heart.toFixed(2)) },
        { name: "strength", value: parseFloat(strength.toFixed(2)) },
        { name: "soul", value: parseFloat(soul.toFixed(2)) },
        { name: "mind", value: parseFloat(mind.toFixed(2)) }
      ];


      setScoreRankingOne(RankedScoresOne)



      const RankedScores = [
        { name: "Collaborative", value: parseFloat(collaborative.toFixed(2)) },
        { name: "Strategic", value: parseFloat(strategic.toFixed(2)) },
        { name: "Performance", value: parseFloat(performance.toFixed(2)) },
        { name: "Visionary", value: parseFloat(visionary.toFixed(2)) }
      ];

      setScoreRanking(RankedScores);


      setSnapshotResults([
        // averagePercentages?.[1]?.avg,
        // averagePercentages?.[0]?.avg,
        // averagePercentages?.[2]?.avg,
        // averagePercentages?.[3]?.avg,
        strength,
        heart,
        soul,
        mind
      ])

      setLeadershipResult([
        // averagePercentagesLeadership?.[2]?.avg,
        // averagePercentagesLeadership?.[3]?.avg,
        // averagePercentagesLeadership?.[1]?.avg,
        // averagePercentagesLeadership?.[0]?.avg,
        performance,
        collaborative,
        visionary,
        strategic
      ])
    }


  }, [averagePercentages, averagePercentagesLeadership])

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page">
        <style>
          {`
            .container { display: flex; flex-direction: column; align-items: center; text-align: center; }
            .header-text { font-size: 24px; font-weight: 700; color: #426B88; margin-bottom: 20px; margin-top: 19px; line-height: 41px; margin-bottom: 0 }
            .chart { height: 290px; width: 371px; } 
            .footer { display: flex; justify-content: space-between; border-top: 1px solid #00577D; padding-top: 10px; margin-top: 20px; }
            .footerTextHeading { font-size: 12px; font-weight: 700; color: #76A3BE; }
            .footerText { font-size: 10px; color: #76A3BE; }
            .subText { font-family: Lato; font-weight: 400; font-size: 12px; line-height: 18px; letter-spacing: 0px; margin: 0px; color: #245775 }
          `}
        </style>

        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center" }}>
            <h2 style={{ fontSize: "11px", fontFamily: "Helvetica", fontWeight: "700", lineHeight: "15px", color: "#000000", margin: "0px" }}>LIFE FLOW (360)</h2>
            {SquareWithArrow()}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center" }}>
            <h2 style={{ fontSize: "11px", fontFamily: "Helvetica", fontWeight: "700", lineHeight: "15px", color: "#000000", margin: "0px" }}>LEADERSHIP FLOW (360)</h2>
            {SquareWithArrowTwo()}
          </div>
        </div>

        <div className="container" >
          {/* <h1 className="header-text">WHO YOU ARE vs HOW YOU LEAD</h1>
          <p className="subText">These charts reflect the combined results calculated with all the participant scores (including yours) for Starter Quadrant and Leadership Style.</p> */}
          <SpiderChart360
            snapshotResult={snapshotResult}
            starterLabel={starterLabel}
            leadershipResult={leadershipResult}
            leadershipLabel={leadershipLabel}
          />
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default AlignmentFlowSecond360;